import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const NotActivatedSharedFolder: Illustration = (props) => (
  <svg viewBox="0 0 333 226" {...illustrationProps(props, { width: 333 })}>
    <path
      fill="#22AE00"
      d="M244.423 135.643c3.383 0 6.151 2.468 5.228 6.479L236 219.693c-.395 2.168-2.285 3.058-4.495 3.067l-105.81.426c-8.611.037-15.142-7.039-13.603-15.485l11-60.382c1.185-6.505 6.853-11.242 13.484-11.271l107.847-.405Z"
    />
    <path
      fill="#FFB3B3"
      d="m177.991 94.065-51.828 29.674c-1.457.833-3.348.269-4.228-1.268l-16.23-28.311a4.35 4.35 0 0 1 1.613-5.94l49.541-28.36a4.358 4.358 0 0 1 5.945 1.614l16.23 28.31c.88 1.537.418 3.455-1.039 4.288l-.004-.007Z"
    />
    <path
      fill="#4D5BE0"
      d="M88.958 61.827a5.021 5.021 0 0 0-.26-1.331c-.914-2.685-3.886-4.104-6.638-3.17-2.753.935-4.243 3.87-3.33 6.554.84 2.467 3.417 3.864 5.965 3.35a11.238 11.238 0 0 0-.717 4.028l-1.904 1.39a3.795 3.795 0 0 0-1.26 4.56c.53 1.237.605 2.567-.344 3.654a3.087 3.087 0 0 0-.082 3.972c2.116 2.623 6.05-.976 8.683-1.13 0 0 12.916 3.375 15.294 3.598 2.377.223 6.149-3.658 3.826-6.305-.779-.887-.124-1.867 1.005-2.84 1.613-1.39.691-3.806-1.005-4.721-1.025-.554-.093-1.63-.193-3.28-.551-9.161-11.865-13.2-19.04-8.33Z"
    />
    <path
      fill="#FFD195"
      d="m104.041 72.057-.133 1.754a2.372 2.372 0 0 0 .331 1.56l1.757 2.853a.955.955 0 0 1-.544 1.414l-1.631.353-.988 3.27c-.014 1.754-1.521 3.132-3.278 2.999l-2.262-.172-6.407 7.16-7.766-4.954 8.855-8.041c-1.865-.243-3.966-1.56-4.447-3.015-.482-1.455.06-2.678 1.072-3 .748-.24 1.952-.587 3.495 1.629 1.175-2.169 1.252-4.25.974-8.67-.029-.45.512-.677.777-.312a8.761 8.761 0 0 1 1.344 2.722c.223.772.858 1.396 1.664 1.449l7.187 1Z"
    />
    <ellipse
      cx="1.328"
      cy="1.322"
      fill="#FF9494"
      rx="1.328"
      ry="1.322"
      transform="rotate(-6.808 703.662 -716.597) skewX(-.088)"
    />
    <path
      fill="#BEC4FF"
      d="m54.172 117.701-.611 1.641 13.884 7.076.8 1.191c3.385 5.045 11.027 4.285 13.362-1.327l10.29-24.734c2.5-6.008.08-12.93-5.616-16.069a7.855 7.855 0 0 0-9.91 1.96l-17.04 21.188a32.678 32.678 0 0 0-5.159 9.074Z"
    />
    <path
      fill="#FFD195"
      d="m80.842 122.854 36.789-8.178a3.262 3.262 0 0 0 1.826-1.129l2.97-3.654c.308-.379.326-.916.044-1.315l-1.619-2.293a1.089 1.089 0 0 0-1.102-.439l-6.629 1.326-.684-1.478c-.262-.565-.949-.806-1.486-.49-.948.558-1.035.834-1.561 1.945-.942 1.991-2.713 2.894-4.687 3.14l-14.64 1.823 1.434-7.936-12.788 1.056-.195 15.741a1.91 1.91 0 0 0 2.328 1.881Z"
    />
    <path
      fill="#BEC4FF"
      d="M92.712 98.108c.209-9.416-.681-12.73-4.9-13.032-5.29-.382-8.544 4.406-8.907 7.294-.745 5.915-.552 8.191-.843 10.604-2.615.499-2.211 8.509.472 8.585l12.983.484c2.424.068 2.348-6.573.914-6.98.082-3.095.254-5.743.28-6.955Z"
    />
    <path
      fill="#FFD195"
      d="m69.603 192.813-7.872-.002.006 12.276 7.871.001-.005-12.275Z"
    />
    <path
      fill="#76C82E"
      fillRule="evenodd"
      d="M59.398 201.07c-.002-3.31 11.653-1.125 11.486 1.146-1.818 5.493-.771 9.054-.653 11.917 0 .007 0 .013.002.021.014.168.266 2.405 3.372 2.789 1.836.227 3.318.991 3.715 2.752.459 2.039.761 3.155-.36 3.802-.822.474-6.02.549-8.64.548-2.752 0-4.38-2.395-6.174-5.501-1.963-3.397-4.055-6.805-5.56-9.411-.238-.411-.953-1.641.456-3.003 2.364-1.847 2.358-2.306 2.356-5.06Z"
      clipRule="evenodd"
    />
    <path
      stroke="#B8E682"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m67.653 207.778 2.301.691M57.339 199.801l1.927 1.463M67.652 212.07l2.216-.248M70.172 216.161l1.096-1.468"
    />
    <path
      stroke="#22AE00"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m55.538 209.196 7.132 11.739a7.625 7.625 0 0 0 6.52 3.666l6.864-.003"
    />
    <path
      fill="#FFD195"
      d="m29.603 177.598-6.132-4.934-7.704 9.565 6.133 4.934 7.703-9.565Z"
    />
    <path
      fill="#76C82E"
      fillRule="evenodd"
      d="M15.995 179.565c.985-1.176 7.277 3.92 8.595 4.981.42.337.51.941.206 1.382-3.134 4.622-2.335 8.76 1.413 12.376 2.276 2.455 3.26 3.451 1.079 6.161-.603.719-1.506 1.798-3.492.138L7.96 191.362c-.36-.301-1.441-1.201-.595-2.944 1.047-1.68 3.33-3.059 4.86-4.267 1.99-1.573 3.384-4.124 3.77-4.586Z"
      clipRule="evenodd"
    />
    <path
      stroke="#B8E682"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m21.246 188.581 2.311.549M14.29 178.642l.613 2.311M20.795 192.747l2.205.006M22.65 197.495l1.532-.965"
    />
    <path
      stroke="#22AE00"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m6.558 191.344 17.52 14.649"
    />
    <path
      fill="#B8E682"
      d="M73.979 132.34s1.887 7.071 2.47 18.517c.583 11.445 1.819 21.981 2.329 31.204.814 14.728-24.795 14.314-25.578 3.911-1.506-20.018-5.91-36.348-6.906-45.473-1.577-14.435 10.679-18.491 10.679-18.491l17.006 10.332Z"
    />
    <path
      fill="#B8E682"
      d="M69.272 138.058c-7.698 13.252-14.383 24.36-28.096 39.971-7.811 8.892-28.352-4.303-20.5-15.304 12.433-17.418 20.599-34.951 33.682-40.617l2.987-.069 11.927 16.019Z"
    />
    <path
      fill="#76C82E"
      d="m51.975 118.147-1.596 1.493a2.779 2.779 0 0 0-.764 2.827c.078.26.257.478.497.605l22.613 11.94a2.804 2.804 0 0 0 2.974-.223c1.615-1.192 1.49-3.645-.239-4.668l-20.75-12.273a2.295 2.295 0 0 0-2.735.299Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m62.026 129.617-2.648 11.977a23.943 23.943 0 0 0-.498 6.944l3.147 42.297"
    />
    <path
      stroke="#7C7FFF"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="M87.648 85.653c-2.23-.212-6.913.287-7.805 3.98-.891 3.693-1.352 10.667-1.033 14.407m0 0 8.76.158m-8.76-.158c-.862.199-2.069.458-2.23 2.149-.159 1.671-.238 3.688-.079 4.377"
    />
    <path
      stroke="#3B0AAF"
      strokeLinecap="round"
      strokeWidth="2.395"
      d="M84.271 67.028c.267-1.12 1.054-2.888 2.507-4.433"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m67.249 191.803-3.177-41.931c-.183-2.409 0-4.831.543-7.185l2.634-11.434M71.817 190.459l-2.721-40.594c-.1-1.503-.006-3.013.282-4.492l2.438-12.526"
    />
    <path
      stroke="#76C82E"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="M54.562 128.996c-3.097 2.127-7.292 7.291-7.174 15.411.098 6.794 2.788 19.951 4.145 27.221"
    />
    <path
      stroke="#D8A060"
      strokeLinecap="round"
      strokeWidth="1.959"
      d="M93.901 82.952s.563 2.595 4.016 3.477"
    />
    <path
      stroke="#D8A060"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m89.27 112.399 9.026-1.102"
    />
    <path
      stroke="#E77070"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m104.07 91.796 39.675 7.058a3.265 3.265 0 0 0 3.652-2.13l13.413-38.103"
    />
    <path
      stroke="#FF9494"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="M98.644 79.754v0c.21.973.893 1.776 1.82 2.14l2.082.818"
    />
    <path
      stroke="#4D5BE0"
      strokeLinecap="round"
      strokeWidth="2.395"
      d="m78.069 70.081 4.04-1.418M89.763 58.856l.14-2.896"
    />
    <path
      fill="#fff"
      d="M99.957 76.781c.641.073.986.112 1.417.004.55-.137 1.786-.822.884-2.113-1.174-1.46-2.383-1.652-3.626-.886-1.15.705-.965 2.764.72 2.93.229.023.428.045.605.065Z"
    />
    <path
      fill="#3B0AAF"
      d="M99.956 76.77c.641.073.986.112 1.417.004.55-.137 1.785-.822.884-2.113-.347-.433-.686-.747-1.027-.957a2.626 2.626 0 0 0-1.435 3.048l.161.018Z"
    />
    <path
      fill="#76C82E"
      d="M144.806 136.174c2.016 7.104 2.188 8.156 6.458 8.138l49.984-.246c5.446-.023 7.208 1.149 8.331 6.474l13.519 62.585c.882 4.084 3.192 7.688 7.071 8.657 1.035.258 1.131 1.613.163 1.613l-117.944.452c-5.451.024-6.478-.001-7.714-6.1-5.76-28.441-16.363-78.922-16.363-78.922-1.491-7.107-.479-10.609 6.788-10.641l42.589-.149c5.464-.023 5.64 2.931 7.118 8.139Z"
    />
    <path
      fill="#B8E682"
      d="M97.198 135.917c-1.22 0-2.134 1.216-1.83 2.736l3.045 12.461c.514 2.012 1.276 2.46 3.357 2.451l36.882-.138c.915 0 2.492-.488 2.134-2.615l-3.743-12.765c-.22-1.52-1.134-2.404-2.658-2.404l-37.187.274Z"
    />
    <path
      fill="#A06433"
      d="M269.349 205.249c-.053.079-.134.15-.153.236-.054.238-.207.274-.424.282-1.227.043-2.453.101-3.681.153-1.246.051-2.491.102-3.738.15-.477.018-.475.011-.673-.432-.03-.067-.097-.116-.146-.174-.057-2.016-.116-4.032-.175-6.048-.042-1.459-.079-3.343-.123-4.803.102-.48.113-.502.539-.401.249.06 3.322.296 4.615.251 1.288-.044 2.58.003 3.866-.131.343-.035.357-.009.416.558-.104 3.042-.216 6.509-.319 9.551-.01.27-.004.538-.005.808h.001Z"
    />
    <path
      fill="#fff"
      d="M269.601 220.829c-3.127.658-9.884-.379-9.884-.379.093-2.071.09-13.2.208-16.81.006-.182.33-.293.485-.197 1.766 1.091 7.35.928 9.079-.192.145-.094.409.003.415.176.17 5.127-.277 15.691-.309 17.402h.006Z"
    />
    <path
      fill="#22AE00"
      d="M269.444 209.101c.947.018 1.022.824 1.016 1.585-.033 3.489.44 6.85.335 10.772-.178 1.235-1.456 1.705-2.589 1.693-3.282-.035-7.005-.08-10.286-.117-3.956-.044-8.545.234-12.5.112-.925-.027-1.964-.967-2.091-1.881-.266-1.968 2.439-4.904 4.286-5.483 2.991-.948 5.994-1.86 8.983-2.813.274-.089.373-.279.297-.569l-.808-3.021c-.211-.79-.168-.865.654-1.049 1.617-.359 3.197-.885 4.838-1.08.351-.042.47.282.579.555.417 1.037.763 2.102 1.239 3.117.217.459.497.63 1 .55.476-.075.702-.318.776-.785.175-1.12.488-1.425 1.63-1.569.857-.108 1.776-.03 2.641-.017Z"
    />
    <path
      stroke="#178000"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="M269.888 223.705h-25.27"
    />
    <path
      fill="#FF9494"
      d="M272.066 191.093v6.042c0 .825-.67 1.495-1.496 1.495h-11.038c-.826 0-1.496-.67-1.496-1.495v-4.789a8.755 8.755 0 0 1-2.246-5.866l2.246-63.557c0-4.852 1.69-8.786 6.546-8.786s16.715 3.934 16.715 8.786c0 0-5.696 55.588-6.262 60.677-.566 5.09-2.14 6.152-2.969 7.493Z"
    />
    <path
      fill="#A06433"
      d="M313.86 186.018c.017.09.01.195.057.267.126.2.045.33-.098.484-.813.871-1.615 1.751-2.422 2.628-.821.889-1.64 1.778-2.463 2.665-.315.339-.318.333-.759.165-.066-.025-.146-.014-.22-.02l-4.271-4.033c-1.03-.972-2.349-2.24-3.382-3.212-.259-.399-.267-.422.095-.645.211-.129 2.483-2.073 3.34-2.99.854-.913 1.773-1.766 2.564-2.74.212-.26.239-.251.669.098 2.016 2.16 4.32 4.617 6.337 6.775.179.192.367.373.551.559l.002-.001Z"
    />
    <path
      fill="#fff"
      d="M324.673 196.836c-1.742 2.567-7.165 6.398-7.165 6.398-1.329-1.506-8.815-9.251-11.18-11.864-.122-.136.034-.442.211-.482 1.97-.446 5.728-4.289 6.196-6.236.04-.168.299-.282.424-.162 3.579 3.47 10.38 11.134 11.511 12.349l.003-.003Z"
    />
    <path
      fill="#22AE00"
      d="M318.113 188.727c.671-.629 1.269-.118 1.779.416 2.338 2.452 4.727 4.676 7.307 7.478.712.98.141 2.17-.656 2.928-2.308 2.192-4.716 4.472-7.025 6.663-2.783 2.642-5.79 5.936-8.625 8.523-3.383 3.092-4.565-4.56-3.456-6.61 1.441-2.68 2.915-5.345 4.351-8.027.13-.248.07-.447-.179-.597l-2.606-1.558c-.682-.407-.703-.488-.255-1.172.883-1.343 1.627-2.776 2.637-4.02.216-.266.518-.121.779-.005.992.441 1.953.948 2.972 1.333.461.173.772.103 1.068-.292.281-.375.274-.696.009-1.071-.636-.898-.625-1.322.073-2.194.524-.654 1.216-1.221 1.827-1.795Z"
    />
    <path
      stroke="#178000"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="m328.118 198.07-17.326 17.494"
    />
    <path
      fill="#FF9494"
      d="M272.415 146.8c.952 10.293 4.338 18.138 10.74 26.012l7.454 10.871c1.885 1.628 4.277 2.008 6.57 1.481l1.945 1.784a1.7 1.7 0 0 0 2.399-.103l6.952-6.778c.634-.69.544-2.51-.147-3.143l-3.217-2.95c-.153-2.386-1.005-4.749-2.575-6.578-3.372-3.927-7.955-11.575-7.955-11.575l-1.747-26.556c1.745-3.628-21.368-9.674-23.443-7.86l3.024 25.395Z"
    />
    <path
      stroke="#E77070"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.942"
      d="m291.535 157.282 3.34-1.047-3.49-1.494M306.092 173.218l-4.784 5.38M272.263 191.66l-7.174.639M265.412 131.016s4.098 20.661 11.884 33.368"
    />
    <path
      fill="#A06433"
      d="M220.862 68.972c-.949-.867-1.566-1.209-3.279-1.817-1.515-.537-2.84-1.165-5.354-2-.523-.225-.604-.05-.699.341-.295 1.214 2.484 2.426 3.213 3.775-1.717-.182-3.791-.435-5.899-.677-1.003-.115-1.737.243-2.259 1.038-.426-.05-.888.325-1.359.698-.616.456-.709.904-.567 1.216.271.591 1.586 1.035 1.586 1.035-.097.843.657 1.189 1.303 1.248 2.809.254 10.985 1.015 11.572 1.754 1.534 2.277 11.357 15.515 13.354 14.096 1.89-1.355 1.655-2.352 3.506-3.756-2.682-3.408-12.323-14.386-15.118-16.95Z"
    />
    <path
      fill="#FFED89"
      d="M260.578 79.074s21.96-7.657 28.243 2.291c4.95 7.837 6.977 38.379 7.545 49.067.108 2.039-1.521 3.719-3.562 3.719l-34.346.004c-3.907 0-6.869-3.523-6.198-7.371l8.318-47.71Z"
    />
    <path
      fill="#BEC4FF"
      d="m312.775 145.168 8.841-37.097c.481-2.018-.796-4.048-2.855-4.538l-34.92-8.314-17.076 9.741-6.599 27.683c-.481 2.018.797 4.048 2.856 4.538l45.157 10.751c2.06.49 4.115-.746 4.596-2.764Z"
    />
    <path
      fill="#97A1FF"
      d="M271.751 132.792c.113-1.291.628-2.481 1.143-3.671.358-.828.716-1.656.939-2.518.089-.345.157-.684.223-1.017.142-.71.279-1.397.616-2.089.496-1.017.736-2.105.9-3.246.071-.5-.126-1.013-.673-1.165-.448-.125-1.106.139-1.179.649-.158 1.138-.395 2.138-.894 3.17-.342.7-.483 1.422-.626 2.153-.08.412-.161.826-.279 1.242-.237.837-.566 1.637-.895 2.435-.535 1.301-1.068 2.596-1.196 4.037-.108 1.203 1.81 1.217 1.918.014l.003.006ZM276.808 135.028c.506-2.788 1.433-5.458 2.36-8.128.613-1.766 1.226-3.531 1.717-5.33.165-.601.417-1.579.715-2.733.819-3.173 1.98-7.671 2.594-9.274.838-2.186 1.396-4.435 1.877-6.73.249-1.18-1.597-1.699-1.848-.515-.485 2.294-1.036 4.534-1.876 6.73-.628 1.641-1.823 6.276-2.643 9.454a260.622 260.622 0 0 1-.666 2.553c-.492 1.802-1.105 3.568-1.718 5.334-.927 2.669-1.853 5.337-2.359 8.125-.212 1.179 1.631 1.708 1.847.514ZM283.612 128.098c-.931 2.686-1.864 5.375-2.37 8.166-.216 1.193-2.059.664-1.847-.515.506-2.79 1.437-5.477 2.368-8.162.659-1.902.507.318 1.848-6.017.25-1.184 2.097-.664 1.847.515-1.327 6.336-1.431 5.093-1.846 6.013ZM289.078 137.627c.113-1.291.628-2.481 1.143-3.672.358-.827.716-1.655.939-2.517.09-.346.157-.684.224-1.017.141-.71.278-1.397.616-2.089.496-1.017.735-2.105.899-3.246.071-.5-.126-1.013-.673-1.165-.448-.125-1.106.139-1.179.649-.158 1.137-.394 2.138-.894 3.169-.342.7-.483 1.422-.625 2.153-.081.412-.162.827-.28 1.243-.237.837-.566 1.637-.894 2.435-.536 1.301-1.068 2.595-1.197 4.037-.107 1.203 1.811 1.217 1.918.014l.003.006ZM294.136 139.863c.505-2.788 1.432-5.458 2.36-8.129.612-1.765 1.225-3.53 1.716-5.329.165-.601.417-1.579.715-2.733.819-3.173 1.98-7.672 2.594-9.275.838-2.186 1.396-4.434 1.877-6.73.249-1.179-1.597-1.698-1.847-.514-.486 2.294-1.036 4.534-1.877 6.73-.628 1.64-1.823 6.275-2.643 9.454-.277 1.075-.511 1.984-.666 2.553-.492 1.802-1.105 3.568-1.718 5.333-.927 2.67-1.853 5.338-2.359 8.125-.212 1.179 1.632 1.709 1.848.515ZM300.939 132.932c-.931 2.687-1.863 5.376-2.37 8.166-.216 1.194-2.059.665-1.847-.514.506-2.79 1.437-5.477 2.368-8.162.615-1.773 1.229-3.544 1.72-5.343.201-.743.378-1.486.554-2.227.359-1.509.716-3.011 1.28-4.484.84-2.196 1.391-4.436 1.876-6.73.251-1.184 2.097-.664 1.848.515-.797 3.806-2.244 7.389-3.142 11.163-.18.758-.361 1.519-.569 2.277-.49 1.797-1.104 3.568-1.718 5.339ZM304.05 140.834c.113-1.291.628-2.481 1.143-3.672.358-.827.716-1.655.939-2.517.089-.346.157-.684.223-1.017.142-.71.279-1.398.617-2.089.496-1.017.735-2.106.899-3.246.071-.501-.126-1.013-.673-1.166-.448-.125-1.106.14-1.179.65-.158 1.137-.395 2.138-.895 3.169-.341.7-.482 1.422-.625 2.153-.08.412-.161.827-.279 1.242-.238.838-.567 1.638-.895 2.436-.535 1.301-1.068 2.595-1.197 4.037-.107 1.203 1.811 1.217 1.919.014l.003.006ZM281.853 103.565l1.989-8.346-17.076 9.741 9.148 2.178c2.661.633 5.318-.965 5.939-3.573Z"
    />
    <path
      fill="#A06433"
      d="m298.794 114.115-5.719 5.903h-5.983s-1.257.191-.695 1.144l3.911 1.338s-3.544 3.966-3.911 4.878c-.366.911-.73 1.757.3 1.836 0 0-1.463 2.021-.921 2.517.829.76 1.948 0 1.948 0 .888.378 2.02-.187 2.585-.187.566 0 2.247-.124 2.768-.565 1.836-1.557 5.174-5.816 11.363-11.911 3.976-3.917-1.683-8.446-5.646-4.953Z"
    />
    <path
      fill="#FFED89"
      fillRule="evenodd"
      d="M268.233 86.6a11.89 11.89 0 0 0-7.906 1.89l-18.022 8.91a6.793 6.793 0 0 1-8.621-.941l-13.012-12.97c-2.609-2.693-1.298-5.825 1.396-8.433 2.695-2.608 5.752-3.704 8.361-1.011l9.093 8.924 13.32-5.804c6.977-3.65 10.994-4.732 16.941-4.05l21.027 4.046c4.946 1.253 13.822 9.72 21.89 16.978 8.069 7.258 7.607 11.381 4.777 15.341-2.83 3.959-11.884 11.878-11.884 11.878-2.83 2.828-16.411-2.261-9.619-12.442l4.527-4.525c-3.397-3.958-8.965-8.596-13.219-10.25l-19.049-7.54Z"
      clipRule="evenodd"
    />
    <path
      stroke="#FFB800"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.942"
      d="M294.955 116.765v0a6.288 6.288 0 0 1 1.082-6.959l4.6-4.955m3.262-3.806-3.262 3.806m0 0L289.186 93.13M238.863 82.195l.748 1.495 1.496-1.495"
    />
    <path
      stroke="#663720"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.438"
      d="M206.298 72.18c.471-.374 2.242-.17 4.265.061.796.092 1.449-.044 2.034-.254m3.642-.802c-1.412-.455-2.367.347-3.642.802m0 0s-.214-.985-.105-1.66m.34-.387s-.3.142-.34.388m0 0s-2.156.18-3.829-.134"
    />
    <path
      stroke="#FFB800"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.942"
      d="m258.699 88.55.96-6.272"
    />
    <path
      fill="#3B0AAF"
      d="M265.158 61.881c-1.142.776-2.834.537-3.3-.33-.513-.952-.48-1.854.194-2.69.217-.27.181-.467.067-.755-.599-1.506-.163-3.364 1.049-4.442.244-.217.34-.4.241-.714-.093-.29-.142-.594-.196-.894-.343-1.922.443-3.477 2.26-4.174.771-.296 1.227-.638 1.374-1.499.162-.951.848-1.537 1.783-1.793.803-.218 1.616-.315 2.433-.07.268.08.435.025.589-.203.954-1.404 2.302-1.664 3.845-1.237.349.096.574.045.812-.193.708-.71 1.56-.796 2.48-.518.775.235 1.519.55 1.964 1.28.192.315.429.221.673.184 1.209-.182 2.278.118 3.216.916a3.366 3.366 0 0 1 1.09 1.696c.098.35.275.588.622.697.066.022.126.062.192.09 1.74.682 2.22 2.114 2.101 3.462-.05.55.063.91.532 1.232.529.365.916.901 1.13 1.508.637 1.801.577 3.544-.482 5.192-.255.398-.566.677-1.023.795-.6.465-1.71.42-2.341-.306-.653-.752-1.298-1.302-2.337-1.363-10.158-.614-15.047 1.465-18.968 4.13Z"
    />
    <path
      fill="#A06433"
      d="M282.37 66.839c1.146.04 2.167-.412 3.057-1.142 3.126-2.565 3.951-6.484 3.127-9.122-.32-1.048-1.604.663-3.632.206-.776-.174-2.16-2.311-3.082-2.35-2.696 2.726-3.854-.388-6.089.346-2.799.92-3.492-1.37-4.151-1.392-.418-.015-.809.453-1.943 1.749-.263.454-.447.795-.269 1.368.185.598-.002.811-.497 1.143-.745.499-4.679 2.407-2.931 3.59.594.402 1.542.703 1.658.921-.087 1.445-.334 2.5-.411 3.85-.056.89.136 3.223 3.783 3.016 0 0-.716 3.668-1.022 5.457-.089.517.069 1.049.474 1.383 2.363 1.954 5.531 1.507 8.547.524a1.741 1.741 0 0 0 1.172-1.42c.55-3.858 1.165-8.068 1.165-8.068l1.044-.06Z"
    />
    <path
      fill="#14035E"
      d="M281.293 66.261c.313-.908 2.435-.138 4.304-3.093.627-.992.396-2.363-.567-2.816-1.335-.627-3.225.59-3.736 2.167-.078.242-.428.308-.635-.133-.509-1.074-.187-3.301.404-4.342.661-1.165.597-2.305.205-3.448-.102-.296.099-.618.409-.575 1.489.206 2.182 1.405 3.076 1.463 1.056.07 2.182-1.104 3.202-.995 1.3.138 1.529.854 1.63 1.623.336 2.502.123 4.933-.944 7.247-1.522 3.307-4.45 6.326-7.977 6.193-.023-.405.629-3.29.629-3.29Z"
    />
    <path
      fill="#815032"
      d="M267.114 63.938s-.356-1.02-.004-1.44c.582-.695 2.841.297 3.423.684.415.275.483.584.418.686.249.54-.767 2.038-2.437 1.865-1.153-.122-1.067-.104-1.067-.104s-.488-.062-.441-.772c.02-.309.156-.632.302-.897l-.194-.022Z"
    />
    <path
      stroke="#663720"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.456"
      d="m267.325 64.185 2.623.2a2.696 2.696 0 0 0 1.975-.655l.251-.217M270.879 69.293l3.63-.613"
    />
    <path
      stroke="#663720"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.438"
      d="m268.233 60.819.341.15"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.456"
      d="M271.202 58.905c-.063.418.03.883.558 1.18.72.403 1.349.131 1.664-.351"
    />
    <path
      stroke="#14035E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.456"
      d="M272.643 55.345c1.059-.06 2.631.697 3.164 1.495"
    />
    <path
      fill="#BEC4FF"
      d="m190.059 63.493 38.884-8.381c2.115-.456 3.45-2.569 2.985-4.724l-7.894-36.542-16.85-11.66-29.016 6.254c-2.116.456-3.451 2.57-2.985 4.724L185.39 60.42c.465 2.155 2.554 3.53 4.669 3.074Z"
    />
    <path
      fill="#97A1FF"
      d="M186.449 26.742c1.266-.475 2.617-.526 3.969-.578.94-.036 1.88-.072 2.791-.25.366-.072.714-.16 1.058-.248.731-.186 1.439-.366 2.242-.36 1.18.008 2.312-.257 3.459-.615.503-.16.896-.575.794-1.157-.085-.477-.629-.976-1.142-.815-1.141.363-2.189.59-3.384.585-.813-.005-1.555.187-2.307.381-.424.11-.851.22-1.295.297-.895.153-1.795.204-2.693.255-1.465.082-2.923.164-4.337.692-1.181.44-.331 2.248.85 1.807l-.005.006ZM186.622 32.498c2.85-.779 5.78-1.11 8.709-1.44 1.937-.218 3.873-.436 5.787-.784a240.17 240.17 0 0 0 2.893-.558c3.354-.658 8.109-1.59 9.893-1.735 2.434-.196 4.8-.683 7.177-1.264 1.221-.296.879-2.264-.348-1.967-2.377.576-4.732 1.067-7.176 1.265-1.826.148-6.725 1.11-10.084 1.77h-.001c-1.136.223-2.096.412-2.701.522-1.916.349-3.854.567-5.791.785-2.929.33-5.856.66-8.706 1.44-1.204.33-.873 2.3.348 1.966ZM196.203 35.771c-2.946.334-5.896.668-8.749 1.447-1.22.334-1.552-1.635-.347-1.966 2.852-.78 5.8-1.114 8.745-1.447 1.944-.22 3.887-.44 5.801-.788a74.459 74.459 0 0 0 2.344-.48c1.582-.343 3.156-.683 4.795-.816 2.444-.198 4.799-.689 7.176-1.264 1.227-.297 1.569 1.67.347 1.967-2.376.58-4.742 1.068-7.176 1.264-1.614.13-3.173.467-4.74.806-.795.171-1.592.344-2.399.49-1.911.347-3.853.567-5.797.787ZM188.811 45.685l1.621 9.183c.223 1.264 2.154.93 1.93-.34l-1.621-9.183c-.223-1.264-2.154-.929-1.93.34ZM193.594 49.698c-.278-1.49-.555-2.979-.972-4.436-.146-.526.315-1.072.794-1.156.561-.099.992.296 1.142.815.416 1.457.694 2.947.971 4.436.278 1.49.555 2.98.972 4.436.146.526-.315 1.072-.794 1.157-.561.099-.992-.296-1.142-.816-.416-1.456-.694-2.946-.971-4.436ZM197.255 44.446c.417 1.457.694 2.947.972 4.436.277 1.49.555 2.98.971 4.436.15.52.581.915 1.142.816.479-.085.94-.63.794-1.157-.417-1.457-.694-2.946-.972-4.436-.277-1.49-.555-2.979-.971-4.436-.15-.52-.581-.914-1.142-.815-.479.084-.94.63-.794 1.156ZM204.919 47.703c-.278-1.49-.555-2.979-.972-4.436-.145-.526.315-1.072.794-1.156.561-.1.992.295 1.142.815.416 1.457.694 2.947.971 4.436.278 1.49.556 2.98.972 4.436.146.526-.315 1.072-.794 1.157-.561.099-.992-.296-1.142-.816-.416-1.457-.694-2.946-.971-4.436ZM207.551 42.632c.416 1.457.694 2.947.972 4.436.277 1.49.555 2.98.971 4.436.15.52.581.914 1.142.816.479-.085.939-.631.794-1.157-.417-1.457-.694-2.946-.972-4.436-.277-1.49-.555-2.98-.971-4.436-.15-.52-.581-.914-1.142-.816-.479.085-.94.631-.794 1.157ZM215.215 45.89c-.278-1.49-.556-2.98-.972-4.437-.146-.526.315-1.072.794-1.156.561-.099.992.296 1.142.815.416 1.457.694 2.947.971 4.436.278 1.49.555 2.98.972 4.436.145.526-.315 1.072-.794 1.157-.561.099-.992-.296-1.142-.816-.416-1.457-.694-2.946-.971-4.436ZM217.847 40.818c.417 1.457.694 2.947.972 4.436.277 1.49.555 2.98.971 4.436.15.52.581.915 1.142.816.479-.085.94-.631.794-1.157-.417-1.457-.694-2.946-.972-4.436-.277-1.49-.555-2.979-.971-4.436-.15-.52-.581-.914-1.142-.815-.479.084-.94.63-.794 1.156ZM222.966 44.522c-.277-1.49-.555-2.979-.971-4.436-.146-.526.315-1.072.794-1.156.561-.099.991.295 1.141.815.417 1.457.694 2.947.972 4.436.277 1.49.555 2.98.971 4.436.146.526-.315 1.073-.793 1.157-.562.099-.992-.296-1.142-.816-.417-1.457-.694-2.946-.972-4.436ZM215.287 15.73l8.748-1.886-16.85-11.66 2.067 9.573c.602 2.785 3.301 4.562 6.035 3.973Z"
    />
    <path
      fill="#FFDE9B"
      d="M316.459 64.14c-.106-.678-.462-1.328-.995-1.7-.512-.355-1.22-.405-1.807-.328-.382.05-.713.156-1.019.417-.236.2-.402.478-.507.783-.281.122-.452.406-.482.767-.055.644.175 1.294.557 1.782.146.29.341.528.623.678.301.16.617.26.944.316.692.117 1.516.167 2.078-.383.221-.216.331-.494.367-.794a1.92 1.92 0 0 0 .105-.2c.181-.433.206-.872.136-1.338Zm-2.656.183s.01-.011 0 0ZM120.962 49.702a61.082 61.082 0 0 1-.673-2.981 1.254 1.254 0 0 1 .918-1.473c.623-.172 1.349.285 1.474.916.191.988.423 1.97.664 2.947a62.552 62.552 0 0 1 3.122-.706 1.255 1.255 0 0 1 1.474.916c.173.623-.285 1.348-.917 1.473-1.035.2-2.063.444-3.087.697.259 1.035.526 2.067.838 3.089.197.654-.313 1.306-.918 1.473-.668.187-1.286-.306-1.474-.917a59.807 59.807 0 0 1-.829-3.053c-.989.248-1.976.506-2.953.803-.655.197-1.307-.312-1.474-.917-.187-.667.306-1.285.917-1.472.962-.295 1.939-.55 2.918-.795Z"
    />
    <path
      fill="#FFBE5C"
      d="M58.268 26.424c-2.727 5.045-5.446 10.09-8.173 15.134l-1.176 2.174c-.694 1.29 1.302 2.306 2 1.01 2.728-5.044 5.447-10.088 8.174-15.133l1.176-2.174c.695-1.29-1.302-2.306-2-1.01Z"
    />
    <path
      fill="#FFBE5C"
      d="m46.252 32.418 14.86 7.651c.694.356 1.386.712 2.075 1.072 1.282.657 2.34-1.361 1.057-2.027l-14.861-7.65c-.693-.356-1.386-.712-2.075-1.072-1.282-.657-2.339 1.361-1.056 2.026Z"
    />
    <path
      fill="#FFBE5C"
      d="M63.747 31.089c-5.45 1.722-10.89 3.444-16.34 5.166-.781.25-1.563.492-2.344.743-1.399.445-.758 2.599.64 2.154 5.45-1.723 10.89-3.444 16.34-5.166.782-.25 1.563-.493 2.345-.743 1.398-.445.757-2.6-.64-2.154Z"
    />
    <path
      fill="#FFBE5C"
      d="M51.19 26.907c1.624 5.35 3.239 10.703 4.862 16.054l.677 2.245c.417 1.386 2.584.695 2.167-.69-1.615-5.352-3.238-10.703-4.852-16.055l-.678-2.246c-.416-1.385-2.584-.694-2.167.691h-.008Z"
    />
    <path
      fill="#FFBE5C"
      fillRule="evenodd"
      d="M258.266 24.062c.234-.462.077-1.012-.351-1.23-.429-.217-.966-.02-1.201.442l-1.523 2.996-1.092-3.826a.826.826 0 0 0-1.097-.557.99.99 0 0 0-.601 1.182l1.092 3.825-3.297-1.673c-.428-.218-.965-.02-1.2.442-.235.461-.078 1.012.351 1.229l2.785 1.413-2.944 1.084a.989.989 0 0 0-.6 1.181c.137.48.628.73 1.096.557l3.738-1.376-1.805 3.55c-.235.462-.078 1.012.351 1.23.428.217.966.019 1.2-.443l1.523-2.996.806 2.821c.137.48.628.73 1.097.557a.99.99 0 0 0 .6-1.182l-.805-2.823 2.783 1.413c.428.217.965.019 1.2-.442.235-.462.078-1.012-.351-1.23l-3.295-1.672 3.549-1.306a.99.99 0 0 0 .601-1.182.826.826 0 0 0-1.097-.557l-2.755 1.015 1.242-2.442Z"
      clipRule="evenodd"
    />
    <path
      stroke="#FFDE9B"
      strokeWidth="2.427"
      d="M34.707 64.018a3.638 3.638 0 0 1-3.64 3.636 3.638 3.638 0 0 1-3.642-3.636 3.638 3.638 0 0 1 3.641-3.636 3.638 3.638 0 0 1 3.64 3.636ZM323.049 35.89a3.639 3.639 0 0 1-3.641 3.636 3.639 3.639 0 0 1-3.641-3.637 3.639 3.639 0 0 1 3.641-3.636 3.639 3.639 0 0 1 3.641 3.636Z"
    />
    <path
      stroke="#22AE00"
      strokeLinecap="round"
      strokeWidth="1.942"
      d="M106.791 149.806c-2.912-1.94-4.563-9.214 2.427-9.214s11.65 7.274 7.766 7.274c-2.05 0-1.455-4.85 3.884-4.85 5.34 0 6.311 4.85 12.136 4.85"
    />
  </svg>
);
